import D2fromD1 from "./D2fromD1";
import D3fromD1 from "./D3fromD1";
import D4fromD1 from "./D4fromD1";
import D5fromD1 from "./D5fromD1";
import D6fromD1 from "./D6fromD1";
import D7fromD1 from "./D7fromD1";
import D8fromD1 from "./D8fromD1";
import D9fromD1 from "./D9fromD1";
import D10fromD1 from "./D10fromD1";
import D11fromD1 from "./D11fromD1";
import D12fromD1 from "./D12fromD1";
import D16fromD1 from "./D16fromD1";
import D20fromD1 from "./D20fromD1";
import D24fromD1 from "./D24fromD1";
import D27fromD1 from "./D27fromD1";
import D30fromD1 from "./D30fromD1";
import D40fromD1 from "./D40fromD1";
import D45fromD1 from "./D45fromD1";
import D60fromD1 from "./D60fromD1";

export const DivisionalDirectory = [
  {
    path: "/theory/divisional-charts-from-d1/d2",
    element: <D2fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d3",
    element: <D3fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d4",
    element: <D4fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d5",
    element: <D5fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d6",
    element: <D6fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d7",
    element: <D7fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d8",
    element: <D8fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d9",
    element: <D9fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d10",
    element: <D10fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d11",
    element: <D11fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d12",
    element: <D12fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d16",
    element: <D16fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d20",
    element: <D20fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d24",
    element: <D24fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d27",
    element: <D27fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d30",
    element: <D30fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d40",
    element: <D40fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d45",
    element: <D45fromD1 />,
  },
  {
    path: "/theory/divisional-charts-from-d1/d60",
    element: <D60fromD1 />,
  },
];
